import React from 'react'

export const Icon = (props) => {
  switch (props.name) {
    case 'gift-wrapping':
      return (
        <svg
          viewBox='0 0 18 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...props}
        >
          <path
            d='M17.28 5.12h-3.321c.306-.516.486-1.13.486-1.787C14.445 1.495 13.052 0 11.34 0 10.409 0 9.57.444 9 1.145 8.43.445 7.591 0 6.66 0 4.948 0 3.555 1.495 3.555 3.333c0 .657.178 1.27.486 1.788H.72c-.398 0-.72.345-.72.773v4.83c0 .107.081.194.18.194h.9v8.31c0 .427.322.772.72.772h14.4c.398 0 .72-.345.72-.773v-8.31h.9c.099 0 .18-.086.18-.192V5.894c0-.428-.322-.773-.72-.773zM9.765 3.334c0-.932.707-1.69 1.575-1.69.869 0 1.575.758 1.575 1.69 0 .933-.706 1.691-1.575 1.691H9.765v-1.69zM6.66 1.643c.869 0 1.575.758 1.575 1.69v1.691H6.66c-.869 0-1.575-.758-1.575-1.69 0-.933.707-1.691 1.575-1.691zM1.53 9.275V6.763h6.705v2.512H1.53zm1.08 1.643h5.625v7.44H2.61v-7.44zm12.78 7.44H9.765v-7.44h5.625v7.44zm1.08-9.083H9.765V6.763h6.705v2.512z'
            fill='#000'
          />
        </svg>
      )
    case 'amazon':
      return (
        <svg viewBox='0 0 1000 301.354' {...props}>
          <path
            d='M620.38 235.668c-58.111 42.833-142.34 65.686-214.86 65.686-101.685 0-193.227-37.61-262.483-100.161-5.44-4.919-.565-11.622 5.964-7.792 74.74 43.486 167.153 69.647 262.613 69.647 64.38 0 135.202-13.32 200.322-40.961 9.837-4.179 18.064 6.442 8.444 13.581'
            fillRule='evenodd'
          />
          <path
            d='M644.54 208.027c-7.4-9.49-49.102-4.483-67.82-2.263-5.702.696-6.572-4.266-1.436-7.836 33.213-23.375 87.712-16.628 94.067-8.793 6.355 7.88-1.654 62.508-32.865 88.583-4.788 4.004-9.359 1.871-7.226-3.44 7.009-17.498 22.723-56.718 15.28-66.251'
            fillRule='evenodd'
          />
          <path
            d='M578.026 32.908V10.186c0-3.439 2.612-5.746 5.746-5.746H685.5c3.265 0 5.877 2.35 5.877 5.746v19.458c-.044 3.264-2.786 7.53-7.661 14.277l-52.714 75.263c19.588-.48 40.264 2.437 58.024 12.449 4.005 2.264 5.093 5.572 5.398 8.836v24.246c0 3.309-3.657 7.183-7.487 5.18-31.298-16.41-72.868-18.195-107.474.174-3.526 1.916-7.226-1.915-7.226-5.223v-23.027c0-3.7.043-10.012 3.743-15.627l61.072-87.581h-53.15c-3.264 0-5.876-2.307-5.876-5.703M206.939 174.684h-30.95c-2.96-.218-5.31-2.438-5.528-5.268V10.578c0-3.178 2.655-5.702 5.963-5.702h28.86c3.004.13 5.398 2.437 5.616 5.31V30.95h.566c7.53-20.067 21.677-29.426 40.743-29.426 19.37 0 31.472 9.359 40.178 29.426 7.487-20.067 24.507-29.426 42.746-29.426 12.971 0 27.162 5.354 35.824 17.368 9.794 13.363 7.792 32.778 7.792 49.798l-.044 100.248c0 3.177-2.655 5.746-5.963 5.746h-30.906c-3.09-.218-5.572-2.7-5.572-5.746V84.752c0-6.704.61-23.419-.87-29.774-2.307-10.665-9.228-13.668-18.196-13.668-7.487 0-15.322 5.005-18.5 13.015-3.177 8.01-2.872 21.416-2.872 30.427v84.186c0 3.177-2.656 5.746-5.964 5.746h-30.906c-3.134-.218-5.572-2.7-5.572-5.746l-.043-84.186c0-17.717 2.916-43.79-19.066-43.79-22.243 0-21.373 25.42-21.373 43.79v84.186c0 3.177-2.655 5.746-5.963 5.746M778.958 1.524c45.923 0 70.779 39.437 70.779 89.583 0 48.448-27.467 86.885-70.78 86.885-45.096 0-69.646-39.438-69.646-88.582 0-49.45 24.855-87.886 69.647-87.886m.261 32.43c-22.81 0-24.246 31.08-24.246 50.45 0 19.414-.304 60.854 23.985 60.854 23.985 0 25.116-33.43 25.116-53.803 0-13.407-.566-29.425-4.614-42.136-3.482-11.056-10.403-15.366-20.24-15.366M909.285 174.684h-30.819c-3.09-.218-5.572-2.7-5.572-5.746l-.043-158.882c.26-2.917 2.83-5.18 5.963-5.18H907.5c2.699.13 4.919 1.958 5.528 4.44v24.289h.566c8.663-21.721 20.807-32.081 42.18-32.081 13.886 0 27.424 5.006 36.13 18.717C1000 32.951 1000 54.325 1000 69.691v99.987c-.348 2.786-2.916 5.006-5.963 5.006H963c-2.83-.218-5.18-2.307-5.485-5.006V83.402c0-17.368 2.003-42.789-19.37-42.789-7.53 0-14.452 5.05-17.89 12.71-4.354 9.708-4.92 19.371-4.92 30.08v85.535c-.043 3.177-2.742 5.746-6.05 5.746M496.931 98.812c0 12.058.305 22.113-5.79 32.821-4.918 8.706-12.753 14.06-21.416 14.06-11.883 0-18.848-9.054-18.848-22.418 0-26.378 23.637-31.167 46.054-31.167v6.704m31.21 75.436c-2.045 1.828-5.005 1.96-7.312.74-10.273-8.531-12.145-12.493-17.76-20.633-16.977 17.325-29.034 22.505-51.017 22.505-26.074 0-46.315-16.062-46.315-48.23 0-25.117 13.581-42.224 32.995-50.582 16.803-7.4 40.265-8.705 58.2-10.751v-4.005c0-7.357.565-16.062-3.788-22.418-3.743-5.702-10.97-8.053-17.368-8.053-11.797 0-22.287 6.05-24.855 18.587-.523 2.786-2.569 5.529-5.398 5.66l-29.992-3.222c-2.524-.566-5.354-2.612-4.614-6.486C417.795 10.97 450.703 0 480.13 0c15.061 0 34.736 4.005 46.62 15.41 15.06 14.06 13.624 32.82 13.624 53.236v48.23c0 14.496 6.008 20.851 11.666 28.686 1.96 2.786 2.394 6.138-.13 8.227-6.312 5.268-17.543 15.062-23.724 20.546l-.043-.087M91.194 98.812c0 12.058.305 22.113-5.79 32.821-4.918 8.706-12.71 14.06-21.416 14.06-11.883 0-18.805-9.054-18.805-22.418 0-26.378 23.637-31.167 46.011-31.167v6.704m31.21 75.436c-2.045 1.828-5.005 1.96-7.312.74-10.273-8.531-12.102-12.493-17.76-20.633-16.977 17.325-28.99 22.505-51.017 22.505C20.285 176.86 0 160.798 0 128.63c0-25.117 13.625-42.224 32.995-50.582 16.803-7.4 40.265-8.705 58.199-10.751v-4.005c0-7.357.566-16.062-3.744-22.418-3.787-5.702-11.012-8.053-17.368-8.053-11.796 0-22.33 6.05-24.899 18.587-.522 2.786-2.568 5.529-5.354 5.66L9.794 53.845c-2.525-.566-5.31-2.612-4.614-6.486C12.101 10.97 44.966 0 74.392 0c15.06 0 34.736 4.005 46.62 15.41 15.06 14.06 13.624 32.82 13.624 53.236v48.23c0 14.496 6.007 20.851 11.666 28.686 2.003 2.786 2.438 6.138-.087 8.227-6.312 5.268-17.542 15.062-23.723 20.546l-.087-.087'
            fillRule='evenodd'
          />
        </svg>
      )
    case 'circle':
      return (
        <svg viewBox='0 0 512 512' {...props}>
          <path d='M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z'></path>
        </svg>
      )
    case 'dropdown-arrow':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 256 256'
          {...props}
        >
          <path d='M225.813 48.907L128 146.72 30.187 48.907 0 79.093 128 207.093 256 79.093z'></path>
        </svg>
      )
    case 'logo':
      return (
        <svg viewBox='0 0 225 225' {...props}>
          <path d='M64.8 76l29.4 29H105V94.5L80.8 70.8 56.5 47.1h-21zM144.3 71L120 94.9V105h11.4l29.1-29 29-29H179l-10.5.1zM64.5 149.5l-30 29.4 10.6.1h10.6l24.7-24.1 24.6-24.1V120h-5.2l-5.3.1zM120 125.2l-.1 5.3 24.8 24.2 24.8 24.2h21l-30-29.4-30-29.5H120z' />
        </svg>
      )
    case 'place':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='-119 -21 682 682.667'
          {...props}
        >
          <path d='M216.21 0C93.548 0-6.25 99.797-6.25 222.46-6.25 376.638 216.43 640 216.43 640s222.242-270.945 222.242-417.54C438.672 99.798 338.879 0 216.21 0zm67.122 287.598c-18.508 18.504-42.812 27.757-67.121 27.757-24.305 0-48.617-9.253-67.117-27.757-37.012-37.008-37.012-97.227 0-134.239 17.922-17.93 41.761-27.804 67.117-27.804 25.355 0 49.191 9.879 67.121 27.804 37.012 37.012 37.012 97.23 0 134.239zm0 0'></path>
        </svg>
      )
    case 'close':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' {...props}>
          <path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z' />
        </svg>
      )
    case 'cart':
      return (
        <svg viewBox='0 0 32 42' {...props}>
          <path
            d='m718 10a8 8 0 0 0 -16 0h-8l.027 34h31.973v-34zm-7.987-5.37a5.115 5.115 0 0 1 4.987 5.37h-10a5.136 5.136 0 0 1 5.013-5.37zm13.987 36.37h-27v-28h5v2h3v-2h10v2h3v-2h5v29z'
            fillRule='evenodd'
            transform='translate(-694 -2)'
          />
        </svg>
      )
    case 'search':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 512 512'
          {...props}
        >
          <path d='M464 428L339.92 303.9a160.48 160.48 0 0030.72-94.58C370.64 120.37 298.27 48 209.32 48S48 120.37 48 209.32s72.37 161.32 161.32 161.32a160.48 160.48 0 0094.58-30.72L428 464zM209.32 319.69a110.38 110.38 0 11110.37-110.37 110.5 110.5 0 01-110.37 110.37z'></path>
        </svg>
      )
    case 'lock':
      return (
        <svg
          viewBox='0 0 13 16'
          className='prefix__CheckoutLockIcon-sc-1smm7df-0 prefix__bJeeSh'
          {...props}
        >
          <path
            fill='#FFF'
            d='M8.92 5.333v-1.17A2.383 2.383 0 006.539 1.78h-.155A2.383 2.383 0 004 4.163v1.168c-.598.048-1.194.112-1.789.192V4.162A4.169 4.169 0 016.391 0h.155a4.169 4.169 0 014.164 4.163v1.362a30.542 30.542 0 00-1.79-.192zM.939 7.205a29.751 29.751 0 0111.064 0c.49.093.844.523.84 1.021v6.278a.933.933 0 01-.757.916l-.567.107a27.149 27.149 0 01-10.097 0l-.57-.107a.933.933 0 01-.76-.916V8.133a.934.934 0 01.76-.916l.087-.012zm4.487 5.859a2.87 2.87 0 002.086 0 .231.231 0 00.135-.298l-.543-1.532a1.021 1.021 0 10-1.268 0l-.543 1.532a.231.231 0 00.133.298z'
          />
        </svg>
      )
    case 'facebook':
      return (
        <svg viewBox='0 0 8 16' {...props}>
          <path d='M7.235 8.005H5.096V16H1.928V8.005H.42V5.181h1.508V3.353C1.928 2.046 2.52 0 5.125 0l2.348.009v2.743H5.769c-.278 0-.673.146-.673.768v1.661h2.417l-.278 2.824z' />
        </svg>
      )
    case 'instagram':
      return (
        <svg viewBox='0 0 512 512' {...props}>
          <path d='M352 0H160C71.648 0 0 71.648 0 160v192c0 88.352 71.648 160 160 160h192c88.352 0 160-71.648 160-160V160C512 71.648 440.352 0 352 0zm112 352c0 61.76-50.24 112-112 112H160c-61.76 0-112-50.24-112-112V160C48 98.24 98.24 48 160 48h192c61.76 0 112 50.24 112 112v192z' />
          <path d='M256 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zm0 208c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z' />
          <circle cx={393.6} cy={118.4} r={17.056} />
        </svg>
      )
    case 'unmute':
      return (
        <svg viewBox='0 0 24 24' {...props}>
          <path d='M0 0h24v24H0z' fill='none' />
          <path d='M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0021 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 003.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' />
        </svg>
      )
    case 'mute':
      return (
        <svg viewBox='0 0 24 24' {...props}>
          <path d='M0 0h24v24H0z' fill='none' />
          <path d='M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' />
        </svg>
      )

    default:
      return null
  }
}
